import React from 'react';
import { CheckboxInput, TextLead } from '@awarego-ui/components';
import HtmlField from '../../../components/inputs/htmlField';

const CustomizableHtmlField = ({
    label,
    fieldName,
    enabledFieldName,
    form,
    initialValue,
    onEnabledChange,
    defaultValue,
    showReset = false,
}) => {
    const field = form.$(fieldName);
    const enabledField = form.$(enabledFieldName);
    const mrkdownField = form.$(`mrkdwn_${fieldName}`);
    const isEnabled = enabledField.value === '1';

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        const currentValue = field.value;
        enabledField.set(checked ? '1' : '0');

        if (checked) {
            const isEmpty =
                currentValue === undefined ||
                currentValue === null ||
                currentValue === '';
            const nextValue = isEmpty ? defaultValue || '' : currentValue;
            if (isEmpty) {
                field.set(nextValue);
            }
            onEnabledChange && onEnabledChange(fieldName, nextValue || '');
        }
    };

    const handleReset = () => {
        if (!defaultValue) return;
        field.set(defaultValue);
        onEnabledChange && onEnabledChange(fieldName, defaultValue);
    };

    return (
        <div className="form-group">
            <CheckboxInput
                label={label}
                checked={isEnabled}
                onChange={handleCheckboxChange}
            />
            {isEnabled && (
                <>
                    <HtmlField
                        key={fieldName}
                        field={field}
                        mrkdownField={mrkdownField}
                        showLabel={true}
                        initialValue={initialValue}
                    />
                    {showReset && defaultValue && (
                        <TextLead
                            themed
                            bold
                            link
                            role="button"
                            tabIndex={0}
                            onClick={handleReset}
                            style={{ fontSize: '12px', marginTop: '8px' }}
                        >
                            Reset to default
                        </TextLead>
                    )}
                </>
            )}
        </div>
    );
};

export default CustomizableHtmlField;

